
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's0fbf6dc6a1966408': `Următorul`,
's144508ac0e146c46': `Nu s-au găsit date`,
's3f9c368cd44f682b': `A apărut o eroare`,
's5d929ff1619ac0c9': `Căutare`,
's716a6024e3fe999c': `Arată`,
's761665218da1556a': `Deschide meniul derulant`,
's76ddb3a843ed8e06': `Șterge căutarea`,
's859e1270b0736efc': `Închide meniul derulant`,
's8bf9dd3eac79af25': `În prezent nu există înregistrări de afișat.`,
'sa26d7a273074cbf9': `Nu există date disponibile`,
'sb1ba2131b9a7c7b0': `Mergi la`,
'sbaace8219b5f4612': `Selectează tot`,
'sc2b31c8d71636c74': str`Pagina ${0}`,
'sf3ff78cc329d3528': `Anteriorul`,
    };
  